import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enJson from "./en.json";
import nlJson from "./nl.json";
import frJson from "./fr.json";

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    debug: false, // used for logging
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: enJson,
      },
      nl: {
        translation: nlJson,
      },
      fr: {
        translation: frJson,
      },
    },
  });

export default i18n;
